import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress,Statistic ,Select  } from 'antd';
import { transfer,transferBnb,balanceOf,signer } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";

import { useTranslation } from 'react-i18next'
import {getDateInfo, addIdoBnb,addIdoJie} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';

import { max } from 'moment';

const nowTime = Date.parse(new Date()) / 1000
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}
const { Countdown } = Statistic;
const Dash = (props) => {
    const navigate = useNavigate()
    const audioRef = useRef(null);
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [list,setList] = useState([])

    const [all,setAll] = useState(0)
    const [layer,setLayer] = useState(0)
    const [levelNode,setLevelNode] = useState(0)
    const [levelPledge,setLevelPledge] = useState(0)
    const [myAddress,setMyAddress] = useState("0x..")
    const [myTime,setMyTime] = useState("-")
    const [nodeBonus1,setNodeBonus1] = useState(0)
    const [nodeBonus2,setNodeBonus2] = useState(0)
    const [nodeYe,setNodeYe] = useState(0)

    const [allNodeBonus,setAllNodeBonus] = useState(0)
    const [yiNodeBonus,setYiNodeBonus] = useState(0)
    const [yiNodeBonusToken,setYiNodeBonusToken] = useState(0)

    const [ji,setJi] = useState("")
    const [per,setPer] = useState("")
    const [jiAdd,setJiAdd] = useState("")
    const [bcbse,setBcbse] = useState("")

    const [yesSmall,setYesSmall] = useState("")
    const [todaySmall,setTodaySmall] = useState("")
    const [todaySmallAdd,setTodaySmallAdd] = useState("")
    const [todayBigAdd,setTodayBigAdd] = useState("")
    const [todayAddNew,setTodayAddNew] = useState("")
    const [pai,setPai] = useState("")


    const ref = useRef()

   
   

    const _getTuanInfo = () =>{
        if(props.address.length>0 && props.isLogin){
            getDateInfo().then(res=>{
                if(res.code == 0){
                //     setReceiveAddress(res.data.receive)
                //     setReceiveJieAddress(res.data.receive1)
                //     setLevelJie(res.data.levelJie)
                //    setMintPrice(res.data.price)
                //     setMintBnb(res.data.eth)
                //     setMaxMint(res.data.total)
                //     setMinted(res.data.minted)
                //     setPer(res.data.per)
                
                //   setList(res.data.list || [])
                //   setList1(res.data.list1 || [])

                

                    
                setYesSmall(res.data.p_yes_small)
                setTodaySmall(res.data.p_today_small)
                setTodaySmallAdd(res.data.p_today_small_add)
                setTodayBigAdd(res.data.p_today_big_add)
                setTodayAddNew(res.data.p_today_add_new)
                setPai(res.data.p_pai)

                setPer(res.data.p_per)
                setJi(res.data.p_ji)
                setJiAdd(res.data.p_ji_add)
                setBcbse(res.data.bcbse)

                setAllNodeBonus(res.data.allNodeBonus)
                setYiNodeBonus(res.data.yiNodeBonus)
                setYiNodeBonusToken(res.data.yiNodeBonusToken)

                setAll(res.data.all)
                setLayer(res.data.layer)
                setLevelNode(res.data.level_node)
                setLevelPledge(res.data.level_pledge)
                setMyAddress(res.data.my_address)
                setMyTime(res.data.my_time)
                setNodeBonus1(res.data.node_bonus1)
                setNodeBonus2(res.data.node_bonus2)
                setNodeYe(res.data.node_ye)

              
                  
                    
                }else{
                    message.error(res.msg)
                }
               console.log(res)
            })
        }
    }

  

 

  

    

   




    

 


    
  





    useEffect(() => {
        
        props.setIsTiao(true)
        window.scrollTo(0, 0)
            // if(props.address.length>0 && !props.isLogin){
            //     setShowJoin(true)
            // }
            // _allIdoETH()
            // _getIdoList()



            // _balanceOf()
             _getTuanInfo()
            // const timer = setInterval(() =>{_getTuanInfo()},20000)
            // ref.current = timer
            // return ()=>{
            //     clearInterval(ref.current)
            // }
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    const clearTimer = () =>{
        clearInterval(ref.current)
    }

    return (
        <>
            <Head/>
     
           
                      {/* <div className=' bg-[#F1F5F9] w-full lg:w-1/3   pt-20 text-white flex flex-col z-10'></div>    */}
            
            <div style={{"backgroundColor":"#000628"}} className='  w-full lg:w-1/3   pt-20 text-white flex flex-col z-10 indexBg33'>
                <div  className='w-full h-16 px-4 flex flex-row justify-start items-center'>
                    <div className='mt-4 w-full h-12  flex flex-row justify-start items-center'>
                    <img onClick={()=>window.history.back()} alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                    <span className='text-2xl oblod text-gray-100'>{t('dash.表盘数据')}</span>
                    </div>
                
                </div>
                {/*  */}

                <div className="w-full mt-5 py-15  px-4 ">
                    <div className=" bg-[#000F3A]  mt-0 flex flex-col gap-6 rounded-xl border border-[#01409f]   p-4 pb-2">
                        <div className="flex basis-full flex-col mb-2 ">
                            <div className="flex flex-row justify-start items-start">
                                
                                <div className='mr-4'>
                                    <svg t="1769842581785" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="25711" width="50" height="50"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#424A60" p-id="25712"></path><path d="M934.523586 801.121103C922.924138 688.286897 827.603862 600.275862 711.697655 600.275862h-104.977655A24.09931 24.09931 0 0 1 582.62069 576.176552v-11.387586c0-10.292966 6.69131-19.102897 16.331034-22.722207 102.470621-38.523586 172.632276-206.636138 158.384552-325.437793C743.883034 104.500966 652.711724 14.141793 540.495448 1.588966a251.851034 251.851034 0 0 0-27.100689-1.553656l-0.847449-0.017655C375.790345-0.282483 264.827586 110.486069 264.827586 247.172414c0 106.354759 67.213241 260.502069 161.456552 295.353379 9.233655 3.407448 15.095172 12.588138 15.095172 22.439724v11.211035c0 13.312-10.78731 24.09931-24.09931 24.09931h-104.977655c-115.906207 0-211.226483 88.011034-222.825931 200.845241C181.72469 935.688828 336.525241 1024 512 1024s330.27531-88.311172 422.523586-222.878897z" fill="#FBCE9D" p-id="25713"></path><path d="M591.307034 116.70069c65.588966 18.025931 127.346759 58.368 166.894345 111.616-0.282483-3.901793-0.406069-7.891862-0.865103-11.70538C743.883034 104.500966 652.711724 14.141793 540.495448 1.588966a251.851034 251.851034 0 0 0-27.100689-1.553656l-0.847449-0.017655c-122.173793-0.264828-223.514483 88.187586-243.78262 204.499862h0.088276c3.160276 4.449103 6.249931 8.951172 9.622068 13.24138 1.235862-1.536 2.489379-3.054345 3.760552-4.555035 35.310345-42.01931 94.296276-51.74731 144.472276-29.501793a123.586207 123.586207 0 0 0 164.599172-67.001379z" fill="#6C797A" p-id="25714"></path><path d="M934.523586 801.121103C922.924138 688.286897 827.586207 600.275862 711.697655 600.275862H688.551724l-105.931034 105.931035h-141.24138l-52.965517-35.310345-60.539586-70.62069h-15.571862c-115.888552 0-211.226483 88.011034-222.825931 200.845241C181.72469 935.688828 336.525241 1024 512 1024s330.27531-88.311172 422.523586-222.878897z" fill="#E7ECED" p-id="25715"></path><path d="M759.172414 960.300138c12.093793-6.69131 23.834483-13.929931 35.310345-21.53931V829.793103h-35.310345v130.507035zM264.827586 960.300138V829.793103h-35.310345v108.967725c11.475862 7.609379 23.216552 14.848 35.310345 21.53931z" fill="#CCD5D6" p-id="25716"></path><path d="M459.034483 670.896552h105.931034v105.931034h-105.931034z" fill="#38454F" p-id="25717"></path><path d="M440.690759 1018.950621c23.304828 3.248552 47.104 5.049379 71.309241 5.049379 24.399448 0 48.357517-1.818483 71.838897-5.12L547.310345 776.827586h-70.62069l-35.998896 242.123035z" fill="#546A79" p-id="25718"></path><path d="M459.034483 685.02069L388.413793 600.275862h-85.733517a1.730207 1.730207 0 0 0-1.606621 2.365793L370.758621 776.827586l88.275862-58.844689V685.02069zM721.319724 600.275862H635.586207l-70.62069 84.744828v32.962207L653.241379 776.827586l69.667311-174.185931a1.712552 1.712552 0 0 0-1.588966-2.365793z" fill="#FFFFFF" p-id="25719"></path></svg>
                                </div>
                                <div className="w-full py-2 flex flex-col justify-start items-start text-xs font-semibold text-gray-100 ">
                                    <span>{myAddress}</span>
                                    <span className=' mt-1 text-gray-400'>{myTime}</span>
                                </div>
                            </div>
                            <div className='w-full mt-6 py-6 px-4 border border-[#01409f] bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.节点身份')}
                                </div>
                                <div className="w-full text-xl text-yellow-500 rounded-md flex flex-row items-center justify-start" >
                                     {levelNode==1?t('mint.首富节点'):levelNode==2?t('mint.五行社区'):levelNode==3?t('mint.创世节点'):"-"}
                                </div>
                            </div>
                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f] bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.社区等级')}
                                </div>
                                <div className="w-full text-xl text-yellow-500 rounded-md flex flex-row items-center justify-start" >
                                     S{levelPledge}
                                </div>
                            </div>

                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f] bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.社区层级')}
                                </div>
                                <div className="w-full text-xl text-yellow-500 rounded-md flex flex-row items-center justify-start" >
                                     {layer}
                                </div>
                            </div>
                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f] bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.我的总资产')}
                                </div>
                                <div className="w-full text-xl text-yellow-500 rounded-md flex flex-row items-center justify-start" >
                                     $<NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={all}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={4} />
                                </div>
                            </div> 
                        </div>

                        
                    </div>
                </div>

                {/*  */}
                <div className="w-full mt-5 py-15  px-4 ">
                    <div className=" bg-[#000F3A]  mt-0 flex flex-col gap-6 rounded-xl border border-[#01409f]   p-4 pb-2">
                        <div className="flex basis-full flex-col mb-2 ">
                            <div className="flex flex-row justify-start items-center">
                                <div className=" mr-1 flex flex-row justify-start items-center text-base font-semibold text-gray-100 ">
                                    {t('dash.节点数据')}
                                </div>
                                <div>
                                    <svg t="1769778510009" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13417" width="30" height="30"><path d="M949.11 598.58c-5.97 20.15-13.81 39.93-23.51 59.34-2.61 5.6-5.6 10.82-8.96 16.42-5.97 10.82-13.06 21.27-20.53 31.35-8.59 11.57-18.29 22.76-29.11 33.22l-15.3 15.67-39.93 39.93-70.91 70.91c-9.7 9.7-19.78 18.29-29.86 26.5-17.17 13.43-35.45 24.63-54.49 33.96-89.94 45.16-197.05 44.78-286.99-0.37-18.66-8.96-36.95-20.53-53.74-33.59-10.45-8.21-20.53-16.79-30.23-26.5l-70.91-70.91-39.56-39.93-15.3-15.3c-24.63-24.63-44.78-52.25-59.34-81.73-1.87-2.61-2.99-5.6-4.48-8.59-7.46-16.42-13.81-33.22-18.29-50.01-5.23-18.29-8.59-36.58-10.45-55.24-9.33-92.55 21.65-188.84 92.55-259.38L285.93 158.2c125.4-125.77 329.54-125.77 454.94 0l126.14 125.77c85.09 85.08 112.33 206.38 82.1 314.61z" fill="#505FF5" p-id="13418"></path><path d="M925.9 657.91c-2.61 5.6-5.6 10.82-8.96 16.42-5.97 10.82-13.06 21.27-20.53 31.35-8.59 11.57-18.29 22.76-29.11 33.22L852 754.58l-39.93 39.93-70.91 70.91c-9.7 9.7-19.78 18.29-29.86 26.5-17.17 13.43-35.45 24.63-54.49 33.96-89.94 45.16-197.05 44.78-286.99-0.37-18.66-8.96-36.95-20.53-53.74-33.59-10.45-8.21-20.53-16.79-30.23-26.5l-70.91-70.91-39.56-39.93-15.3-15.3c-24.63-24.63-44.78-52.25-59.34-81.73C147.02 499.68 281 379.88 446.33 354.13c21.64-3.73 44.41-5.6 67.18-5.6 22.76 0 45.53 1.87 67.55 5.6 164.95 25.75 299.31 145.92 344.84 303.78z" fill="#FFFFFF" opacity=".15" p-id="13419"></path><path d="M812.63 778.46c0 5.22 0 10.82-0.74 16.05l-70.91 70.91c-9.7 9.7-19.78 18.29-29.86 26.5-17.17 13.43-35.45 24.63-54.49 33.96-89.94 45.16-197.05 44.78-286.99-0.37-18.66-8.96-36.95-20.53-53.74-33.59-10.45-8.21-20.53-16.79-30.23-26.5l-70.91-70.91c-0.75-5.23-0.75-10.45-0.75-16.05 0-101.89 51.13-192.2 129.13-245.94 38.44-26.87 83.6-44.78 132.86-51.13 12.32-1.49 24.63-2.24 37.32-2.24 12.69 0 25.38 0.75 37.69 2.24a299.308 299.308 0 0 1 133.23 51.5c77.63 54.12 128.39 143.68 128.39 245.57z" fill="#FFFFFF" opacity=".2" p-id="13420"></path><path d="M719.33 778.09c0 57.85-23.88 110.47-62.7 147.79-89.94 45.16-197.05 44.78-286.99-0.37-38.44-37.32-62.32-89.57-62.32-147.42 0-13.81 1.49-26.87 3.73-39.93 17.91-89.94 94.42-158.99 188.47-164.96 4.48-0.75 8.96-0.75 13.81-0.75s9.7 0 14.18 0.75c93.67 6.34 170.18 75.01 188.09 164.96 2.24 13.06 3.73 26.12 3.73 39.93z" fill="#FFFFFF" opacity=".25" p-id="13421"></path><path d="M700.84 402l-114-114a65.528 65.528 0 0 0-46.32-19.19H363.79c-31.58 0-57.18 25.6-57.18 57.18v371.43c0 31.58 25.6 57.18 57.18 57.18h299.05c31.58 0 57.18-25.6 57.18-57.18v-249.1c0-17.37-6.9-34.03-19.18-46.32zM532.19 642.29H418.5c-9.77 0-17.67-7.9-17.67-17.67s7.9-17.67 17.67-17.67h113.69c9.77 0 17.67 7.9 17.67 17.67s-7.9 17.67-17.67 17.67z m14.56-209.84L430.99 548.21c-3.45 3.45-7.97 5.18-12.49 5.18s-9.04-1.73-12.49-5.18c-6.9-6.9-6.9-18.09 0-24.99l115.76-115.76c6.9-6.9 18.09-6.9 24.99 0s6.9 18.08-0.01 24.99z" fill="#FFFFFF" p-id="13422"></path></svg>
                                </div>
                            </div>
                            <div className='w-full mt-2 py-6 px-4  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.节点直推收益')}1
                                </div>
                                <div className="w-full text-xl text-yellow-500 rounded-md flex flex-row items-center justify-start" >
                                     <NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={nodeBonus1}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={4} /> USDTB
                                </div>
                            </div>

                            <div className='w-full mt-4 py-6 px-4  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.节点直推收益')}2
                                </div>
                                <div className="w-full text-xl text-yellow-500 rounded-md flex flex-row items-center justify-start" >
                                     <NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={nodeBonus2}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={4} /> USDTB
                                </div>
                            </div>
                            <div className='w-full mt-4 py-6 px-4  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.释放收益')}
                                </div>
                                <div className="w-full text-xl text-yellow-500 rounded-md flex flex-row items-center justify-start" >
                                     <NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={yiNodeBonusToken}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={4} /> USDTB
                                </div>
                            </div>
                            <div className='w-full mt-4 py-6 px-4  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.当前价值')} | {t('dash.最大价值')}
                                </div>
                                <div className="w-full text-xl text-yellow-500 rounded-md flex flex-row items-center justify-start" >
                                     $<NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={yiNodeBonus}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={0} />
                                        <span className=' mx-4'>|</span>
                                        $<NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={allNodeBonus}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={0} /> 
                                </div>
                            </div>
                            <div className='w-full mt-4 py-6 px-4  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.节点业绩')}
                                </div>
                                <div className="w-full text-xl text-yellow-500 rounded-md flex flex-row items-center justify-start" >
                                     $<NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={nodeYe}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={4} />
                                </div>
                            </div> 
                        </div>

                        
                    </div>
                </div>
                
                {/*  */}
                <div className="w-full mt-10 py-15  px-4 ">
                    <div className=" bg-[#000F3A]  mt-0 flex flex-col gap-6 rounded-xl border border-[#01409f]   p-4 pb-2">
                        <div className="flex basis-full flex-col mb-2 ">
                            <div className="flex flex-row justify-start items-center">
                                <div className="mr-1 flex flex-row justify-start items-center text-base font-semibold text-gray-100 ">
                                    {t('dash.质押数据')}
                                </div>
                                <div>
                                    <svg t="1769778579460" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16437" width="30" height="30"><path d="M512 150.528c-109.568 0-198.656 89.6-198.656 198.656V419.84l63.488-1.536V339.968c0-69.632 56.832-126.464 126.464-126.464h17.92c69.632 0 126.464 56.832 126.464 126.464v83.456l63.488-1.024V349.184c-0.512-109.056-89.6-198.656-199.168-198.656z" fill="#7A7AF9" p-id="16438"></path><path d="M674.816 403.456H349.184C269.312 403.456 204.8 463.872 204.8 537.6v201.216c0 74.24 64.512 134.144 144.384 134.144h325.12c79.872 0 144.384-59.904 144.384-134.144V537.6c0.512-73.728-64-134.144-143.872-134.144z" fill="#CCDAFF" p-id="16439"></path><path d="M544.768 675.328c0 16.384-14.848 30.208-32.768 30.208s-32.768-13.824-32.768-30.208v-73.728c0-16.384 14.848-30.208 32.768-30.208s32.768 13.824 32.768 30.208v73.728z" fill="#7A7AF9" p-id="16440"></path></svg>
                                </div>
                            </div>
                            <div className='w-3/5 mt-8 mb-3 py-1 bg-gradient-to-b from-[#0161F6] to-[#0161F6]    text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'>{t('dash.我的质押')}</div>
                            <div className='w-full mt-2 py-6 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.我的质押总量')}
                                </div>
                                <div className="w-full text-xl text-blue-300 rounded-md flex flex-row items-center justify-start" >
                                     0.0000 USDTB
                                </div>
                            </div>

                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.我的历史质押价值')}
                                </div>
                                <div className="w-full text-xl text-blue-300 rounded-md flex flex-row items-center justify-start" >
                                     $0.0000
                                </div>
                            </div>

                            <div className='w-3/5 mt-8 mb-3 py-1 bg-gradient-to-b from-[#0fa29e] to-[#14d6cf]    text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'>{t('dash.我的业绩')}</div>
                            <div className='w-full mt-2 py-6 px-4 border border-[#01409f]  bg-[#000628] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.质押总业绩')}
                                </div>
                                <div className="w-full text-xl text-[#0fa29e] rounded-md flex flex-row items-center justify-start" >
                                     $0.0000
                                </div>
                            </div>

                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f]  bg-[#000628] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.质押小区业绩')}
                                </div>
                                <div className="w-full text-xl text-[#0fa29e] rounded-md flex flex-row items-center justify-start" >
                                     $0.0000
                                </div>
                            </div>


                            <div className='w-3/5 mt-8 mb-3 py-1 bg-gradient-to-b from-[#027623] to-[#027623]    text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'>{t('dash.我的收益')}</div>
                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.累积质押收益')}
                                </div>
                                <div className="w-full text-xl text-green-500 rounded-md flex flex-row items-center justify-start" >
                                     0.0000
                                </div>
                            </div>
                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.累积质押推广收益')}
                                </div>
                                <div className="w-full text-xl text-green-500 rounded-md flex flex-row items-center justify-start" >
                                     0.0000
                                </div>
                            </div>
                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.累积质押点差收益')}
                                </div>
                                <div className="w-full text-xl text-green-500 rounded-md flex flex-row items-center justify-start" >
                                     0.0000
                                </div>
                            </div>
                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.累积质押超越收益')}
                                </div>
                                <div className="w-full text-xl text-green-500 rounded-md flex flex-row items-center justify-start" >
                                     0.0000
                                </div>
                            </div>
                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.累积质押平级收益')}
                                </div>
                                <div className="w-full text-xl text-green-500 rounded-md flex flex-row items-center justify-start" >
                                     0.0000
                                </div>
                            </div>

                            <div className='w-3/5 mt-8 mb-3 py-1 bg-gradient-to-b from-[#f66301] to-[#f66301]    text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'>{t('dash.我的参数')}</div>
                            <div className='w-full mt-2 py-6 px-4 border border-[#01409f]  bg-[#000628] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.基础收益率')}
                                </div>
                                <div className="w-full text-xl text-[#f66301] rounded-md flex flex-row items-center justify-start" >
                                     <NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={per}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={2} /> %
                                </div>
                            </div>

                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f]  bg-[#000628] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.当前点差')}
                                </div>
                                <div className="w-full text-xl text-[#f66301] rounded-md flex flex-row items-center justify-start" >
                                     <NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={ji}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={2} />%
                                </div>
                            </div>

                            <div className='w-full mt-4 py-6 px-4 border border-[#01409f]  bg-[#000628] rounded-xl flex flex-col items-center justify-between'>
                                <div className="w-full text-lg  text-gray-100 rounded-md flex flex-row items-center justify-start" >
                                     {t('dash.当前点差加成系数')}
                                </div>
                                <div className="w-full text-xl text-[#f66301] rounded-md flex flex-row items-center justify-start" >
                                     +<NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={jiAdd}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={2} />%
                                </div>
                                <div className='w-full mt-4 py-3 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                    <div className="w-full text-lg  text-gray-400 rounded-md flex flex-row items-center justify-start" >
                                        {t('dash.昨日小区锁仓')}
                                    </div>
                                    <div className="w-full text-lg text-red-700 rounded-md flex flex-row items-center justify-start" >
                                        $<NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={yesSmall}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={2} />
                                    </div>
                                </div>
                                <div className='w-full mt-4 py-3 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                    <div className="w-full text-lg  text-gray-400 rounded-md flex flex-row items-center justify-start" >
                                        {t('dash.今日小区锁仓')}
                                    </div>
                                    <div className="w-full text-lg text-red-700 rounded-md flex flex-row items-center justify-start" >
                                        $<NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={todaySmall}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={2} />
                                    </div>
                                </div>
                                <div className='w-full mt-4 py-3 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                    <div className="w-full text-lg  text-gray-400 rounded-md flex flex-row items-center justify-start" >
                                        {t('dash.今日小区新增锁仓')}
                                    </div>
                                    <div className="w-full text-lg text-red-700 rounded-md flex flex-row items-center justify-start" >
                                        $<NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={todaySmallAdd}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={2} />
                                    </div>
                                </div>
                                <div className='w-full mt-4 py-3 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                    <div className="w-full text-lg  text-gray-400 rounded-md flex flex-row items-center justify-start" >
                                        {t('dash.今日全区新增锁仓')}
                                    </div>
                                    <div className="w-full text-lg text-red-700 rounded-md flex flex-row items-center justify-start" >
                                        $<NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={todayBigAdd}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={2} />
                                    </div>
                                </div>
                                <div className='w-full mt-4 py-3 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                    <div className="w-full text-lg  text-gray-400 rounded-md flex flex-row items-center justify-start" >
                                        {t('dash.今日新增有效直推')}
                                    </div>
                                    <div className="w-full text-lg text-red-700 rounded-md flex flex-row items-center justify-start" >
                                        {todayAddNew}
                                    </div>
                                </div>
                                <div className='w-full mt-4 py-3 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                    <div className="w-full text-lg  text-gray-400 rounded-md flex flex-row items-center justify-start" >
                                        {t('dash.BCBSE当前持仓')}
                                    </div>
                                    <div className="w-full text-lg text-red-700 rounded-md flex flex-row items-center justify-start" >
                                        <NumberFormat
                                        thousandsGroupStyle="thousand"
                                        value={bcbse}
                                        prefix=""
                                        decimalSeparator="."
                                        fixedDecimalScale={true}
                                        displayType="text"
                                        type="text"
                                        thousandSeparator={true}
                                        allowNegative={false}
                                        decimalScale={4} />
                                    </div>
                                </div>
                                <div className='w-full mt-4 py-3 px-4 border border-[#01409f]  bg-[#0c1e52] rounded-xl flex flex-col items-center justify-between'>
                                    <div className="w-full text-lg  text-gray-400 rounded-md flex flex-row items-center justify-start" >
                                        {t('dash.上周榜排行')}
                                    </div>
                                    <div className="w-full text-lg text-red-700 rounded-md flex flex-row items-center justify-start" >
                                        {pai==0?"-":pai}
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                        
                    </div>
                </div>
                {/*  */}
               

                        
                       
              
                
                
                {/*  */}

               

               

                

                <div className=' w-full h-32'></div>
            </div>
            
            
               
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        },
        setIsTiao(value){
            const action ={type:"setIsTiao",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Dash);
